module.exports = __webpack_public_path__ + "img/1alB-j-jid.c095f1f7.jpg";